import { configureStore } from "@reduxjs/toolkit";

import { authReducer } from "./auth.store";
import { userReducer } from "./user.store";

export * from "./auth.store";
export * from "./user.store";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
    },
});
